import type { CompanyView } from '@voll-intelligence/domain';

import { t } from '@web/i18n';
import { Kv, KvSection } from '@web/ui/core/molecules';
import { formatDateOrNull } from '@web/ui/core/utils';

/**
 * The traveler's company as a one-column `KvSection` (id, name, created). An
 * `ui/core` organism because two features show it: the customer screen's
 * Empresa tab and the traveler view. The epoch `createdAt` sentinel renders
 * "Não informado" rather than 01/01/1970.
 */
export function CustomerCompanyPanel({
  company,
}: Readonly<{ company: CompanyView }>): React.JSX.Element {
  const created = formatDateOrNull(company.createdAt);
  return (
    <KvSection icon="building-office" label={t('customers.company.section')} oneColumn>
      <Kv label={t('customers.company.id')} mono empty={!company.id}>
        {company.id || t('customers.empty.notInformed')}
      </Kv>
      <Kv label={t('customers.company.name')} empty={!company.name}>
        {company.name || t('customers.empty.notInformed')}
      </Kv>
      <Kv label={t('customers.company.createdAt')} empty={!created}>
        {created ?? t('customers.empty.notInformed')}
      </Kv>
    </KvSection>
  );
}
